/**
 * AiModelService
 * Read-only service for querying available AI models
 */
import { BaseService } from '../base/BaseService';
/**
 * Read-only service for listing available AI models
 */
export class AiModelService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiModelService.DEFAULT_SERVICE_PATH,
            basePath: AiModelService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET AVAILABLE MODELS ====================
    /**
     * Get all available AI models
     * @returns Array of available AI models
     */
    async getAvailableModels() {
        const response = await this.getAvailableModelsRaw();
        return response.data ?? [];
    }
    /**
     * Get all available AI models with full response
     * @returns ResponseData with array of available AI models
     */
    getAvailableModelsRaw() {
        const url = this.buildUrl();
        return this.http.get(url);
    }
}
AiModelService.DEFAULT_SERVICE_PATH = 'ai-management';
AiModelService.BASE_PATH = 'api/ai/models';
//# sourceMappingURL=AiModelService.js.map